export default __webpack_public_path__ + "static/media/Moeda.3edef352.svg";